import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  ResolveFn,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { GlobalService } from "../services/global.service";

@Injectable()
export class vrsDetailsResolver implements Resolve<any> {
  constructor(private globalService: GlobalService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    
    return route.params.id;
    //return this.globalService.getVRSDetails(route.params.id);

    //   catchError((error) => {
    //     console.log(error);
    //     this.router.navigate(["/app"]);
    //     return of(null);
    //   })
    // );
  }
}
